/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Catch Backend
 * Catch Backend API
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DtoEnvelopePatientServiceCenterDTO,
  HTTPValidationError,
  SearchPatientServiceCentersV1LabsPatientServiceCentersGetParams
} from '.././model';

import { customCatchBackendFetcher } from '../../../client/customFetcher';




/**
 * Search for patient service centers by ZIP code.

Returns a list of available patient service centers for all lab providers
within the specified radius of the given ZIP code.

When order-id is provided, uses the order's state (if available) to determine
which lab providers are available, rather than using the search ZIP code's state.
This ensures NY/NJ residents see only BioReference labs regardless of search location.
 * @summary Search Patient Service Centers
 */
export const searchPatientServiceCentersV1LabsPatientServiceCentersGet = (
    params: SearchPatientServiceCentersV1LabsPatientServiceCentersGetParams,
 signal?: AbortSignal
) => {
      
      
      return customCatchBackendFetcher<DtoEnvelopePatientServiceCenterDTO>(
      {url: `/v1/labs/patient-service-centers/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getSearchPatientServiceCentersV1LabsPatientServiceCentersGetQueryKey = (params?: SearchPatientServiceCentersV1LabsPatientServiceCentersGetParams,) => {
    return [`/v1/labs/patient-service-centers/`, ...(params ? [params]: [])] as const;
    }

    
export const getSearchPatientServiceCentersV1LabsPatientServiceCentersGetQueryOptions = <TData = Awaited<ReturnType<typeof searchPatientServiceCentersV1LabsPatientServiceCentersGet>>, TError = HTTPValidationError>(params: SearchPatientServiceCentersV1LabsPatientServiceCentersGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchPatientServiceCentersV1LabsPatientServiceCentersGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchPatientServiceCentersV1LabsPatientServiceCentersGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchPatientServiceCentersV1LabsPatientServiceCentersGet>>> = ({ signal }) => searchPatientServiceCentersV1LabsPatientServiceCentersGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchPatientServiceCentersV1LabsPatientServiceCentersGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type SearchPatientServiceCentersV1LabsPatientServiceCentersGetQueryResult = NonNullable<Awaited<ReturnType<typeof searchPatientServiceCentersV1LabsPatientServiceCentersGet>>>
export type SearchPatientServiceCentersV1LabsPatientServiceCentersGetQueryError = HTTPValidationError


export function useSearchPatientServiceCentersV1LabsPatientServiceCentersGet<TData = Awaited<ReturnType<typeof searchPatientServiceCentersV1LabsPatientServiceCentersGet>>, TError = HTTPValidationError>(
 params: SearchPatientServiceCentersV1LabsPatientServiceCentersGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchPatientServiceCentersV1LabsPatientServiceCentersGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchPatientServiceCentersV1LabsPatientServiceCentersGet>>,
          TError,
          Awaited<ReturnType<typeof searchPatientServiceCentersV1LabsPatientServiceCentersGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchPatientServiceCentersV1LabsPatientServiceCentersGet<TData = Awaited<ReturnType<typeof searchPatientServiceCentersV1LabsPatientServiceCentersGet>>, TError = HTTPValidationError>(
 params: SearchPatientServiceCentersV1LabsPatientServiceCentersGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchPatientServiceCentersV1LabsPatientServiceCentersGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchPatientServiceCentersV1LabsPatientServiceCentersGet>>,
          TError,
          Awaited<ReturnType<typeof searchPatientServiceCentersV1LabsPatientServiceCentersGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchPatientServiceCentersV1LabsPatientServiceCentersGet<TData = Awaited<ReturnType<typeof searchPatientServiceCentersV1LabsPatientServiceCentersGet>>, TError = HTTPValidationError>(
 params: SearchPatientServiceCentersV1LabsPatientServiceCentersGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchPatientServiceCentersV1LabsPatientServiceCentersGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Search Patient Service Centers
 */

export function useSearchPatientServiceCentersV1LabsPatientServiceCentersGet<TData = Awaited<ReturnType<typeof searchPatientServiceCentersV1LabsPatientServiceCentersGet>>, TError = HTTPValidationError>(
 params: SearchPatientServiceCentersV1LabsPatientServiceCentersGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchPatientServiceCentersV1LabsPatientServiceCentersGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getSearchPatientServiceCentersV1LabsPatientServiceCentersGetQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



